"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFieldById = exports.findSystemById = exports.findMappingIndexById = exports.findFieldIndexById = exports.findWorkflowIndexById = exports.findSystemIndexById = exports.assignClientIdsToSchema = exports.generateClientId = void 0;
var counter = 0;
/**
 * Per-module random session prefix. Makes it impossible for ids generated in
 * a previous module-load (e.g. before HMR or after `INIT_FROM_SAVED`) to
 * collide with newly-issued ids in this session.
 */
var SESSION_PREFIX = (function () {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        var buf = new Uint8Array(4);
        crypto.getRandomValues(buf);
        return Array.from(buf)
            .map(function (b) { return b.toString(16).padStart(2, '0'); })
            .join('');
    }
    return Math.random().toString(36).slice(2, 10);
})();
var randomSuffix = function () {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        var buf = new Uint8Array(4);
        crypto.getRandomValues(buf);
        return Array.from(buf)
            .map(function (b) { return b.toString(16).padStart(2, '0'); })
            .join('');
    }
    return Math.random().toString(36).slice(2, 10);
};
/**
 * Monotonically-increasing client id with a session-stable random prefix and
 * a per-call random suffix. Cryptographically-random when `crypto` is
 * available, falls back to `Math.random()` otherwise. Not used for any
 * security decision; only for stable React keys + reducer lookups.
 */
exports.generateClientId = function (prefix) {
    counter += 1;
    return prefix + "_" + SESSION_PREFIX + "_" + counter + "_" + randomSuffix();
};
/**
 * Walk a schema and assign a fresh `__clientId` to every system, field, and
 * mapping. Mutates the input.
 *
 * Any inbound `__clientId` (e.g. from the API response or a hand-edited
 * config blob) is **always** overwritten — those values must never be
 * trusted. The session-prefixed local id is used instead.
 */
exports.assignClientIdsToSchema = function (schema) {
    schema.systems.forEach(function (system) {
        system.__clientId = exports.generateClientId('sys');
    });
    (schema.workflows || []).forEach(function (workflow) {
        workflow.__clientId = exports.generateClientId('wfl');
    });
    schema.fields.forEach(function (field) {
        field.__clientId = exports.generateClientId('fld');
        field.mapping.forEach(function (mapping) {
            mapping.__clientId = exports.generateClientId('map');
        });
    });
    return schema;
};
var warnMissingId = function (kind, clientId) {
    if (process.env.NODE_ENV !== 'production') {
        // Stale callback or race: id was deleted before this dispatch landed.
        // Surfacing the miss in dev catches bugs (e.g. stored closures) that
        // would otherwise be swallowed silently in production.
        // eslint-disable-next-line no-console
        console.warn("[ai-hub-settings] " + kind + " clientId not found:", clientId);
    }
};
exports.findSystemIndexById = function (systems, clientId) {
    var idx = systems.findIndex(function (system) { return system.__clientId === clientId; });
    if (idx < 0) {
        warnMissingId('system', clientId);
    }
    return idx;
};
exports.findWorkflowIndexById = function (workflows, clientId) {
    var idx = workflows.findIndex(function (workflow) { return workflow.__clientId === clientId; });
    if (idx < 0) {
        warnMissingId('workflow', clientId);
    }
    return idx;
};
exports.findFieldIndexById = function (fields, clientId) {
    var idx = fields.findIndex(function (field) { return field.__clientId === clientId; });
    if (idx < 0) {
        warnMissingId('field', clientId);
    }
    return idx;
};
exports.findMappingIndexById = function (mappings, clientId) {
    var idx = mappings.findIndex(function (mapping) { return mapping.__clientId === clientId; });
    if (idx < 0) {
        warnMissingId('mapping', clientId);
    }
    return idx;
};
exports.findSystemById = function (systems, clientId) { return systems.find(function (system) { return system.__clientId === clientId; }); };
exports.findFieldById = function (fields, clientId) { return fields.find(function (field) { return field.__clientId === clientId; }); };
